import api2 from './api-v2';

const get = async (id, filter) => {
    const client = await api2.getClient();
    const response = await client.get(`deployment-release-jobs`, { params: filter });
    return api2.handleSuccess(response);
};

const getById = async (id) => {
    const client = await api2.getClient();
    const response = await client.get(`deployment-release-jobs/${id}`);
    return api2.handleSuccess(response);
};

const getLogs = async (id) => {
    const client = await api2.getClient();
    const response = await client.get(`deployment-release-jobs/${id}/logs`);
    return api2.handleSuccess(response);
};


export default {
    get,
    getById,
    getLogs
};
